<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="page-layout">
    <div class="container">
      <div class="grid mt-2 col-12">
        <span for="friendemail-copy" class="heading-text"
          >Friend {{ lmodel.emailCopy }}</span
        >
      </div>
    </div>
    <div class="scroll-enable">
      <div class="container">
        <!-- Title start -->
        <div>
          <div class="grid mt-1 line-text">
            <div class="col-6 lg:col-6">
              <span for="saveemail-copy" class="heading-text">
                {{ lmodel.friSaveCodeSectionTitle }}
              </span>
            </div>
            <div
              class="col-6 lg:col-6"
              style="display: flex; justify-content: flex-end"
            >
              <PrimeButton
                id="send-Email"
                name="sendEmail"
                icon="pi pi-send"
                label="Send preview email"
                @click="showPreviewPopup('cs')"
                class="sendemail"
              />
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.friendSaveCodeSubjectToolTip"
                For="friendSaveCodeSubject-tooltip"
                class="control-label"
                >{{ lmodel.friSaveCodeSubject }}</label
              >
              <Textarea
                v-model="vmodel1.friSaveCodesubject"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.friendSaveCodeSubjectPlaceholder"
                class="mt-1"
                id="customerSaveCodeSubject"
              ></Textarea>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top=""
                For="friendmessagePrevText-tooltip"
                class="control-label"
                >{{ staticData.message.prev_text }}</label
              >
              <InputText
                type="text"
                autocomplete="off"
                placeholder=""
                class="mt-1"
                id="customerPreviewText"
              ></InputText>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.friendSaveCodeBodyToolTip"
                For="friendMsgEmailbody-tooltip"
                class="control-label"
                >{{ staticData.message.email_body }}</label
              >
              <Textarea
                v-model="vmodel1.friSaveCodebody"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.friendSaveCodeBodyPlaceholder"
                class="mt-1 textareaBody"
                id="customerFrndMsgEmailbody"
              ></Textarea>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.friendSaveCodeCTAButtonToolTip"
                For="friendMsgEmailbody-tooltip"
                class="control-label"
                >{{ lmodel.friSaveCodeCTAButton }}</label
              >
              <InputText
                id="customerFrndMsgCTAButton"
                type="text"
                class="mt-1"
                :placeholder="lmodel.friGetYourCodeButton"
              ></InputText>
            </div>
          </div>
        </div>
        <!-- Title End -->

        <!-- First Email Reminder -->
        <div>
          <div class="grid mt-3">
            <div class="col-6 lg:col-6">
              <span for="saveemail-copy" class="heading-text">
                {{ lmodel.friFirstReminderSectionTitle }}
              </span>
            </div>
            <div
              class="col-6 lg:col-6"
              style="display: flex; justify-content: flex-end"
            >
              <PrimeButton
                id="send-Email"
                name="sendEmail"
                icon="pi pi-send"
                label="Send preview email"
                @click="showPreviewPopup('r')"
                class="sendemail"
              />
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.friendFirstReminderSubjectToolTip"
                For="friendMsgFirstReminderSubject-tooltip"
                class="control-label"
                >{{ lmodel.friFirstReminderSubject }}</label
              >
              <InputRequiredTextArea
                v-model="vmodel1.friFirstRemsubject"
                id="frndmsgFirstReminderSubject"
                class="mt-1"
                :placeholder="lmodel.friendFirstReminderSubjectPlaceholder"
              ></InputRequiredTextArea>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top=""
                For="friendMsgPrevText-tooltip"
                class="control-label"
                >{{ staticData.message.prev_text }}</label
              >
              <InputRequiredTextArea
                id="friendMsgPrevText"
                class="mt-1"
                placeholder=""
              ></InputRequiredTextArea>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.friendFirstReminderBodyToolTip"
                For="friendMsgPrevText-tooltip"
                class="control-label"
                >{{ staticData.message.email_body }}</label
              >
              <Textarea
                v-model="vmodel1.friFirstRembody"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.friendFirstReminderBodyPlaceholder"
                class="mt-1 textareaBody"
                id="friendFirstReminderBody"
              ></Textarea>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.friendFirstReminderCTAButtonToolTip"
                For="friendFirstReminderCTAButton-tooltip"
                class="control-label"
                >{{ lmodel.friFirstReminderCTAButton }}</label
              >
              <InputText
                id="friendFirstReminderCTAButton"
                class="mt-1"
                :placeholder="lmodel.friGetYourCodeButton"
              ></InputText>
            </div>
          </div>
        </div>

        <!-- first reminder end -->
        <div>
          <div v-if="$route.name == 'ManageDealUpdateById'">
            <SendMailPreview
              :ShowPopup="showPopup"
              userType="frnd"
              :campaignid="this.id"
              :mailType="this.mailType"
              @closepopup="closePopup"
            />
          </div>

          <div class="grid mt-4">
            <div class="col-6 lg:col-6">
              <span for="saveemail-copy" class="heading-text">
                {{ lmodel.friSecondReminderSectionTitle }}
              </span>
            </div>
            <div
              class="col-6 lg:col-6"
              style="display: flex; justify-content: flex-end"
            >
              <PrimeButton
                id="send-Email"
                name="sendEmail"
                icon="pi pi-send"
                label="Send preview email"
                @click="showPreviewPopup('cs')"
                class="sendemail"
              />
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.friendSecondReminderSubjectToolTip"
                For="friendSecondReminderSubject-tooltip"
                class="control-label"
                >{{ lmodel.friSecondReminderSubject }}</label
              >
              <InputRequiredTextArea
                v-model="vmodel1.friSecRemsubject"
                id="friendSecondReminderSubject"
                class="mt-1"
                :placeholder="lmodel.friendSecondReminderSubjectPlaceholder"
              ></InputRequiredTextArea>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                For="friendSecondReminderPrevText-tooltip"
                class="control-label"
                >{{ staticData.message.prev_text }}</label
              >
              <InputRequiredTextArea
                id="friendSecondReminderPrevText"
                class="mt-1"
                placeholder=""
              ></InputRequiredTextArea>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.friendSecondReminderBodyToolTip"
                For="friendSecondReminderSubject-tooltip"
                class="control-label"
                >{{ staticData.message.email_body }}</label
              >
              <Textarea
                v-model="vmodel1.friSecRembody"
                type="text"
                autocomplete="off"
                :placeholder="lmodel.friendSecondReminderBodyPlaceholder"
                class="mt-1 textareaBody"
                id="friendSecondReminderSubject"
              ></Textarea>
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-12">
              <label
                v-tooltip.top="lmodel.friendSecondReminderCTAButtonToolTip"
                For="friendSecondReminderCTAButton-tooltip"
                class="control-label"
                >{{ lmodel.friSecondReminderCTAButton }}</label
              >
              <InputText
                id="friendSecondReminderCTAButton"
                class="mt-1"
                :placeholder="lmodel.friGetYourCodeButton"
              ></InputText>
            </div>

            <!-- final reminder end -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import moment from "moment";
import staticData from "@/staticdata/static.json";
// import SendMailPreview from "@/views/UpdateDealNew/_SendMailPreview.vue";
import SendMailPreview from "@/views/ManageDealUpdate/sendMail.vue";
// import Dialog from "primevue/dialog";

export default {
  components: {
    // Dialog,
    SendMailPreview,
  },

  props: {
    dealId: {
      type: String,
      default: null,
    },
    tabId: {
      type: Number,
      default: 0,
    },
    lmodel: {
      type: Object,
      default: null,
    },
    dmodel: {
      type: Object,
      default: null,
    },
    vmodel: {
      type: Object,
      default: null,
    },
    valmodel: {
      type: Object,
      default: null,
    },
    dealStatus: {
      type: Number,
      default: null,
    },
    isRedealText: {
      type: Boolean,
      default: false,
    },
    customerCampaignDealyDaysError: {
      type: String,
      default: null,
    },
    enableAmbassadorMailsAmb: {
      type: Boolean,
      default: false,
    },
    modelstate: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      staticData: staticData,
      visible: false,
      errorMessage: true,
      isAdvance: false,
      ShowChangePopup: false,
      mailType: "",
      showPopup: false,
      id: "663c88808f6354bc3029a093",
    };
  },
  computed: {
    vmodel1: {
      get() {
        return this.vmodel;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },

  watch: {},
  mounted() {
    document.body.style.overflow = "hidden";
  },
  methods: {
    showPreviewPopup(mailType) {
      this.mailType = mailType;
      this.showPopup = true;
    },
    closePopup() {
      this.showPopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.setting-layout {
  margin-top: 180px;
}
:deep(.setting-layout) {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 260px);
}

.page-layout {
  margin-top: 180px;
  padding: 12px 0px 24px 0px;
}

// .control-label {
//   font-size: 1rem;
//   padding-bottom: 3px;
//   display: block !important;
//   margin-bottom: 0px;
//   padding-top: 7px;
//   font-weight: normal;
//   position: relative;
//   vertical-align: top;
// }

input:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
.p-inputtext:enabled:focus {
  outline: 0 none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

:deep(.p-chips:not(.p-disabled).p-focus .p-chips-multiple-container) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

input {
  color: #777 !important;
  font-size: 0.8rem;
  height: calc(1.5em + 0.75rem + 7px);
  width: 100%;
  box-shadow: none;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}
:deep(.p-inputtext) {
  color: #21211f !important;
  font-size: 16px;
  width: 100%;
  box-shadow: none;
  height: 40px !important;
  // border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
  resize: none;
}
:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
  // border: 1px solid #cedacf;
}
:deep(.p-textarea) {
  height: 79px;
}

:deep(.textareaBody) {
  height: 79px !important;
  .p-inputtextarea {
    height: 79px !important;
  }
}
.scroll-enable {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 260px);
}
</style>
